import { apiSlice } from "../api/apiSlice";
import {
  buildingFacilityListAction,
  companyAccessPointAction,
  companyAccessGroupAction,
  companyAccessGroupDetailAction,
  accessCountsAction,
} from "./facilitySlice";

export const facilityApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      getBuildingFacilityList: builder.query({
        query: ({ companyId }) =>
          `Keyfree/getBuilidingAndFacilityForCompany?companyId=${
            companyId ?? ""
          }`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
            if (result.data.data?.length > 0) {
              dispatch(
                buildingFacilityListAction({
                  buildingFacilityList: result.data.data,
                })
              );
            }
          } catch (err) {}
        },
      }),
      getFacilityDetailsForCompany: builder.query({
        query: ({ companyId, type }) =>
          `Keyfree/getAccessDetails?companyId=${companyId ?? ""}&type=${
            type ?? ""
          }`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
            if (result.data.data?.length > 0) {
              dispatch(
                companyAccessPointAction({
                  companyAccessPointList: result.data.data,
                })
              );
            }
          } catch (err) {}
        },
      }),
      getFacilityGroupDetailsForCompany: builder.query({
        query: ({ companyId, type }) =>
          `Keyfree/getAccessDetails?companyId=${companyId ?? ""}&type=${
            type ?? ""
          }`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
            if (result.data.data?.length > 0) {
              dispatch(
                companyAccessGroupAction({
                    companyAccessGroupList: result.data.data,
                })
              );
            }
          } catch (err) {}
        },
      }),
      addEditFacilities: builder.query({
        query: (body) => ({
          url: "Keyfree/addEditFacilitiesUsingKeyfree",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),
      addEditAccessGroupFacilities: builder.query({
        query: (body) => ({
          url: "Keyfree/addEditAccessGroupFacilities",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),
      getAccessGroupDetail: builder.query({
        query: ({ request }) =>
          `Keyfree/getAccessGroupDetail?request=${request ?? ""}`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
            if (result.data.data?.length > 0) {
              dispatch(
                companyAccessGroupDetailAction({
                  companyAccessGroupDetail: result.data.data,
                })
              );
            }
          } catch (err) {}
        },
      }),
      addEditFacilitiesAccessGroup: builder.query({
        query: (body) => ({
          url: "Keyfree/addEditFacilitiesAccessGroup",
          method: "POST",
          body,
        }),
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
          } catch (err) {
            console.log(err);
          }
        },
      }),
      getFacilityDetailByFacilityId: builder.query({
        query: ({ FacilityId }) =>
          `Keyfree/getFacilityDetailByFacilityId?FacilityId=${FacilityId ?? ""}`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
          } catch (err) {}
        },
      }),
      getAccessCounts: builder.query({
        query: ({ companyId, type }) =>
          `Keyfree/getAccessCount?companyId=${companyId ?? ""}&type=${
            type ?? ""
          }`,
        async onQueryStarted(args, { queryFulfilled, dispatch }) {
          try {
            const result = await queryFulfilled;
            if (result.data && result.data.data) {
              dispatch(
                accessCountsAction({
                  accessCounts: result.data.data,
                })
              );
            }
          } catch (err) {}
        },
      }),
      // getAccessGroupDetail: builder.query({
      //   query: ({ AccessGroupId, AccessType, PropertyUnitIds, UserIds }) =>
      //     `Keyfree/getAccessGroupDetail?AccessGroupId=${AccessGroupId ?? ""}&AccessType=${
      //       AccessType ?? ""
      //     }&PropertyUnitIds=${PropertyUnitIds ?? []}&UserIds=${UserIds ?? []}`,
      //   async onQueryStarted(args, { queryFulfilled, dispatch }) {
      //     try {
      //       const result = await queryFulfilled;
      //       if (result.data.data?.length > 0) {
      //         dispatch(
      //           companyAccessGroupDetailAction({
      //             companyAccessGroupDetail: result.data.data,
      //           })
      //         );
      //       }
      //     } catch (err) {}
      //   },
      // }),
    }),
  });
  
  export const {
    useLazyGetBuildingFacilityListQuery,
    useLazyGetFacilityDetailsForCompanyQuery,
    useLazyGetFacilityGroupDetailsForCompanyQuery,
    useLazyAddEditFacilitiesQuery,
    useLazyAddEditAccessGroupFacilitiesQuery,
    useLazyGetAccessGroupDetailQuery,
    useLazyAddEditFacilitiesAccessGroupQuery,
    useLazyGetFacilityDetailByFacilityIdQuery,
    useLazyGetAccessCountsQuery
  } = facilityApi;
  